import React from 'react';

import './index.pc.scss';
import PcBasicTemplate from 'components/templates/PcBasicTemplate';
import PcInputItem from 'components/molecules/PcInputItem';
import PcStepProgressBar from 'components/molecules/PcStepProgressBar';
import PcPointComment from 'components/molecules/PcPointComment';

import { POINT_COMMENT_MAP } from 'utils/constant';

const PresentPC = ({
  // state
  basicInfoList,
  // onClick
  onClickMainButton,
  // 入力チェック
  valid,
  showLoading,

}) => (
  <div className="AddInfo PC">
    <PcBasicTemplate 
      path={window.location.pathname}
      onClickMainButton={onClickMainButton}
      valid={valid}
      showLoading={showLoading}
    >
      <PcStepProgressBar currentStep='7' />
      <div id="addInfo" className="contents mT60">
        <div className="titleArea">
          <p className="title">基本情報</p>
        </div>
        <PcPointComment labelList={POINT_COMMENT_MAP.basicInfomationCmnt.labelList} pattern={POINT_COMMENT_MAP.basicInfomationCmnt.pattern} />
        <div id='basicInfo' className='basicInfo'>
          {basicInfoList.map((data) => {
            return (
              <span key={data.title}>
                <PcInputItem
                  title={data.title}
                  subTitle={data.subTitle}
                  label={data.label}
                  questionMark={data.questionMark}
                  popUpTitle={data.popUpTitle}
                  popUpDetail={data.popUpDetail}
                >
                  {data.input}
                </PcInputItem>
              </span>
            );
          })}
        </div>
      </div>
    </PcBasicTemplate>
  </div>
);

export default PresentPC;